import { render, staticRenderFns } from "./GalleryForm.vue?vue&type=template&id=461cb780&scoped=true&"
import script from "./GalleryForm.vue?vue&type=script&lang=js&"
export * from "./GalleryForm.vue?vue&type=script&lang=js&"
import style0 from "./GalleryForm.vue?vue&type=style&index=0&id=461cb780&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461cb780",
  null
  
)

export default component.exports